// TwoFAModal.js
import React, { useState } from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import { IoCloseCircle } from "react-icons/io5";
import { HiOutlineQuestionMarkCircle } from "react-icons/hi";
import BackupCode from './BackupCode';
import '../../styles/TwoFAModal.scss';
import CheckCode2f from '../../services/CheckCode2f';

const TwoFAModal = ({ open, userId, handleClose, handleVerify, authResponse }) => {
    const [code, setCode] = useState('');
    const [openBackupModal, setOpenBackupModal] = useState(false);
    const [message, setMessage] = useState(null);

    const handleSubmit = async() => {
        try {
            const resultados = await CheckCode2f({ code, userId }); 
            if (resultados.success == 'success') {
                //hacer el set de setUserAuth
                handleVerify()
                handleClose(userId);
            } else {
                setMessage(resultados.message);
            }
        } catch (error) {
            setMessage('Error al obtener la información de la autenticación.');
        } 
    };

    const handleOpenBackupModal = () => {
        handleClose(userId); 
        setOpenBackupModal(true); 
    };

    const handleCodeChange = (e) => {
        const { value } = e.target;
        if (/^\d*$/.test(value)) {
            setCode(value);
        }
    };
    return (
        <>
            <Modal open={open} onClose={handleClose}>
                <Box className="modalBox">
                    <div className='modalHeader'>
                        <IconButton className="modalCloseButton" onClick={handleClose}>
                            <IoCloseCircle />
                        </IconButton>
                        <h2 className="modalHeader-title">Autenticación de dos Factores Activado</h2>
                    </div>
                    <div className='modalContent'>
                        <div className="modalDisclaimer">
                            <div className="modalDisclaimer-title">
                                <HiOutlineQuestionMarkCircle className='modalDisclaimer-icon' /> 
                                &nbsp;El inicio de sesión a tu cuenta tiene una protección extra.
                            </div>
                            <div className='modalDisclaimer-content'>
                                Necesitamos un paso adicional para asegurarnos que eres tú. Por favor, abre tu Aplicación de Autenticación 
                                en tu dispositivo móvil y proporciona el código aleatorio de 6 dígitos para tu cuenta.
                            </div>
                        </div>
                        <div className="modalContent-input">
                            <TextField
                                fullWidth
                                variant="outlined"
                                margin="normal"
                                label="Código de 6 dígitos"
                                onChange={handleCodeChange}
                                value={code}
                                inputProps={{ maxLength: 6 }}
                                error={!!message}
                                helperText={message ? 'El código que has introducido no es válido. Por favor, inténtalo de nuevo.' : ''}
                            />
                        </div>
                        <div className="modalContent-button">
                            <Button
                                fullWidth
                                variant="contained"
                                className="modalButton tf-button btn-green"
                                onClick={handleSubmit}
                            >
                                Acceder
                            </Button>
                        </div>
                        <div className='modalRespaldo-content'>
                            <div className='modalRespaldo-header'>
                                ¿No puedes acceder a tu Aplicación de Autenticación?
                            </div>
                            <div className='modalRespaldo-body' onClick={handleOpenBackupModal} >
                                Inicia sesión usando tu código de respaldo.
                            </div>
                        </div>
                    </div>
                </Box>
            </Modal>
            <BackupCode open={openBackupModal} usuario={userId} handleClose={() => setOpenBackupModal(false)} handleVerify={handleVerify} />
        </>
    );
};

export default TwoFAModal;
